import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import Form from '../form/Form'

function InterventionResolveDialog({ onClose, value: valueProp, open, ...other }) {
  const [formData, setFormData] = useState({ solution: valueProp?.solution ?? '' })
  const [checkForm, setCheckForm] = useState(false)
  const textFieldRef = useRef(null)

  useEffect(() => {
    setFormData({ solution: valueProp?.solution ?? '' })
    setCheckForm(false)
  }, [valueProp, open])

  const handleEntering = () => {
    textFieldRef.current?.focus()
  }

  const handleCancel = () => {
    setFormData({ solution: valueProp?.solution ?? '' })
    setCheckForm(false)
    onClose(null)
  }

  const handleSave = () => {
    setCheckForm(true)
  }

  const options = {
    fields: [
      [
        {
          name: 'solution',
          label: 'Solution',
          type: 'text-multiline',
          ref: textFieldRef,
          validation: [{ rule: 'req', error: 'Solution obligatoire' }]
        }
      ]
    ]
  }

  return (
    <Dialog
      open={open}
      maxWidth='xs'
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      TransitionProps={{ onEntering: handleEntering }}
      {...other}
    >
      <DialogTitle>Résoudre intervention</DialogTitle>
      <DialogContent dividers>
        <Form
          options={options}
          checkForm={checkForm}
          setCheckForm={setCheckForm}
          setDataParent={(data) => setFormData(data)}
          setIsSubmitParent={() => {
            const trimmed = (formData.solution ?? '').trim()
            onClose(trimmed || null)
          }}
          modeProps='dialog'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Annuler</Button>
        <Button onClick={handleSave}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  )
}

export default InterventionResolveDialog
